export default __webpack_public_path__ + "static/media/board-icon.f9d861ec.svg";